import { render, staticRenderFns } from "./InvestDetail.vue?vue&type=template&id=7cff6e8a&"
import script from "./InvestDetail.vue?vue&type=script&lang=js&"
export * from "./InvestDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvestDetail.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports